export const LAZY_COMPONENTS = {
    FIVERR_BUSINESS: 'fiverr_business_de',
    HOW_FIVERR_WORKS: 'how_fiverr_works_de',
    TESTIMONIALS: 'testimonials_de',
    FIND_EXPERTS: 'find_experts_de',
    PERSONALIZED_SECTION_WRAPPER: 'personalized_section_wrapper_de',
};
